import * as React from 'react';
import { default as PickerSelect, OptionTypeBase } from 'react-select';

import { WBItem } from '@/core';
import { SelectProps } from './model';

const Select: React.FC<SelectProps> = ({
	children,
	icon,
	isDisabled,
	isMulti,
	items,
	label,
	loading,
	onChange,
	placeholder,
	showBorder,
	value,
}) => {
	return (
		<WBItem
			icon={icon}
			isDisabled={isDisabled}
			label={label}
			loading={loading}
			showBorder={showBorder}
			value={
				<>
					{children}
					<div style={{ flex: 1, maxWidth: '100%' }}>
						<PickerSelect
							isDisabled={isDisabled}
							isMulti={isMulti}
							onChange={onChange}
							placeholder={placeholder}
							value={value as OptionTypeBase}
							options={(items || []).map((item) => {
								item.label = item.label || '';
								item.color = item.disabled ? '#999' : '#000';

								return item;
							})}
						/>
					</div>
				</>
			}
		/>
	);
};

export default Select;
